
import { Component, Prop, Vue } from "vue-property-decorator";
import DownloadVue from "../download/Download.vue";
import { RouterHelper } from "@/router/routerHelper";

@Component({
  components: {
    download: DownloadVue,
  },
})
export default class LiteBeeWingFbDownloadVue extends Vue {
  prodName: string = "LiteBee Wing FB";
  prodCode: string = "liteBeeWingFb";
  tabList: Array<any> = [];

  linkData: Array<any> = [
    { name: "首页", link: "/" },
    { name: this.prodName, link: "/product/liteBeeWingFb" },
    { name: "软件下载", link: "#" },
  ];

  mounted() {
    RouterHelper.getProdRouterConfig(this.prodCode, (data: Array<any>) => {
      this.tabList = data;
    });
  }
}
